__turbopack_context__.v({
  "hoverable_opacity": "x_MTfG_hoverable_opacity",
});
